import { render } from "./Datensicherheit.vue?vue&type=template&id=f544f248&scoped=true"
import script from "./Datensicherheit.vue?vue&type=script&lang=js"
export * from "./Datensicherheit.vue?vue&type=script&lang=js"

import "./Datensicherheit.vue?vue&type=style&index=0&id=f544f248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f544f248"]])

export default __exports__